export default __webpack_public_path__ + "static/media/glitchCube.bc5902cc.PNG";